export default "__VITE_ASSET__CIQuJQ5U__"